import { resolveCameraDistance, type CameraDistanceId } from './camera-distance';

/** Preserve the saved zoom range and camera-distance offset at each rendering stage. */
export function manualCameraZoom(zoom: number | null | undefined, distance: CameraDistanceId): number | undefined {
  return zoom == null ? undefined : Math.max(2, Math.min(20, zoom + resolveCameraDistance(distance).zoomOffset));
}
